import React, { Fragment } from 'react';
import { observer } from 'mobx-react';
import { http } from '../../services/HttpInterceptor';
import {
    RouteComponentProps, Link, Redirect
} from "react-router-dom";
import { toast } from 'react-toastify';
import { observable } from 'mobx';
import InputForm from '../site/layout/InputForm';

interface EditAntennaProps extends RouteComponentProps {
    changeToggle(action?: boolean): void
}

@observer export default class EditAntenna extends React.Component<EditAntennaProps> {

    @observable private antenna: any;
    @observable private isLoaded = false;
    @observable private redirect = false;
    @observable private validationErrors: string[] = [];
    @observable private inventory_items: any;

    componentDidMount() {
        this.props.changeToggle(true);
        this.init();
    }

    init = () => {
        const match = this.props.match;
        const id = (match as any).params.id;
        http.get(`/api/antenna/read/${id}`).then((response) => {
            this.antenna = response.data;
        })
        .then(() => {
                return http.get(`/api/inventory/checkitems/${id}/ANTENNA`).then((response) => {
                  this.inventory_items = response.data.response;
                  this.isLoaded = true;
                });
              })
        .catch(() => {
            toast.error("Error cargando antena");
        });
    }

    private handleChange = (event: any) => {
        const { name, value } = event.target;
        this.antenna[name] = value;
    }

    private setValidation = (value: boolean, name: string): void => {
        const error = this.validationErrors.indexOf(name);
        if (value && error === -1) {
            this.validationErrors.push(name);
        } else if (!value && error !== -1) {
            this.validationErrors.splice(error, 1);
        }
    }

    private onSubmit = (): void => {
        if (this.validationErrors.length > 0) {
            toast.error("Hay un error en tu formulario");
            return;
        }

        if (typeof this.antenna.amount === 'string') {
            this.antenna.amount = this.antenna.amount.replace("$", '').replace(/,/g, '');
        }
        this.antenna.phone = this.antenna.phone.replace(/-/g, '');

        http.post(`/api/antenna/update`, JSON.stringify(this.antenna))
            .then(() => {
                toast.success(`Antena actualizada`);
                this.redirect = true;
            }).catch((error) => {
                if(Array.isArray(error)) {
                    error.forEach((val) =>{
                        toast.error(val);
                    })
                } else {
                    toast.error(error);
                }
            });
    }


    render() {
        if (!this.isLoaded) {
            return null;
        }

        if (this.redirect) {
            return <Redirect to="/antenas" />
        }

        return (
          <Fragment>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header card-header-rose card-header-text">
                    <div className="card-text">
                      <h4 className="card-title">
                        Antena: {this.antenna.antenna_name}
                      </h4>
                    </div>
                  </div>
                  <div className="card-body ">
                    <div className="row">
                      <div className="col-sm-10"></div>
                      <div className="col-sm-2">
                        <Link to={`../antenas`}>
                          <button className="btn btn-danger btn-sm  pull-right">
                            <i className="material-icons">highlight_off</i>
                            <div className="ripple-container"></div>
                          </button>
                        </Link>
                      </div>
                    </div>
                    <InputForm
                      name="antenna_name"
                      label="Nombre de la Antena"
                      value={this.antenna.antenna_name}
                      required={true}
                      setValidation={this.setValidation}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="name"
                      label="Nombre"
                      value={this.antenna.name}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="address_street"
                      label="Calle"
                      value={this.antenna.address_street}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="address_colonia"
                      label="Colonia"
                      value={this.antenna.address_colonia}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="text"
                    />
                    <InputForm
                      name="phone"
                      label="Teléfono"
                      value={this.antenna.phone}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="number"
                      format={"###-###-####"}
                    />
                    <InputForm
                      name="amount"
                      label="Cantidad"
                      value={this.antenna.amount}
                      setValidation={this.setValidation}
                      required={true}
                      onChange={this.handleChange}
                      type="number"
                      prefix="$"
                      decimal={2}
                      thousandSeparator={true}
                    />
                    <button
                      onClick={this.onSubmit}
                      type="submit"
                      className="btn btn-primary pull-right"
                    >
                      Actualizar Antena
                    </button>
                  </div>
                  <div className="col-md-6 col-sm-12">
                    <div className="card">
                      <div className="card-header card-header-info card-header-icon">
                        <div className="card-icon">
                          <i className="material-icons">inventory_2</i>
                        </div>
                        <h3 className="card-title">Inventario</h3>
                      </div>
                      <div className="card-body table-responsive">
                        <table className="table table-hover">
                          <thead className="text-warning">
                            <tr>
                              <th>ID</th>
                              <th>Nombre</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.inventory_items &&
                              this.inventory_items.map(
                                (inventory: any, index: any) => {
                                  return (
                                    <tr key={index}>
                                      <td>{inventory.id}</td>
                                      <td>{inventory.name}</td>
                                    </tr>
                                  );
                                }
                              )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Fragment>
        );
    }
}